import { c as _c } from "react/compiler-runtime";
import { isVaultDataEmpty } from '@onefootprint/core';
import type { InvestorProfileDeclaration, InvestorProfileInvestmentGoal } from '@onefootprint/request-types';
import { useTranslation } from 'react-i18next';
import { FieldOrPlaceholder } from '@/components';
import useEntityVault from '@/entities/hooks/use-entity-vault';
import type { WithEntityProps } from '@/entity/components/with-entity';
import useAutoDecryptControls from '@/entity/hooks/use-auto-decrypt-controls';
import createStringList, { createCapitalStringList } from '@/utils/create-string-list';
import Field from '../../../field';
import FieldSection from './components/field-section';
import FinraField from './components/finra-field';
type InvestorProfileFieldsProps = WithEntityProps;
const InvestorProfileFields = t0 => {
  const $ = _c(124);
  const {
    entity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "pages.user.vault.investorProfile"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== entity.data || $[2] !== entity.id) {
    t2 = {
      entityAttributes: entity.data,
      entityId: entity.id
    };
    $[1] = entity.data;
    $[2] = entity.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data
  } = useEntityVault(t2);
  const vaultData = data?.vault;
  const autoDecryptControls = useAutoDecryptControls(entity.kind);
  let t3;
  if ($[4] !== autoDecryptControls || $[5] !== entity.id) {
    t3 = autoDecryptControls.isEntityAutoDecrypting(entity.id);
    $[4] = autoDecryptControls;
    $[5] = entity.id;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const isAutoDecrypting = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isAutoDecrypting || $[10] !== t) {
    t5 = (value, isValueDecrypted) => isValueDecrypted ? <FieldOrPlaceholder data={t($_0 => $_0.employmentStatus.options[value])} /> : <FieldOrPlaceholder data={value} isLoading={isAutoDecrypting} />;
    $[9] = isAutoDecrypting;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== entity || $[13] !== t5) {
    t6 = <Field di="investor_profile.employment_status" entity={entity} renderValue={t5} />;
    $[12] = entity;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <FieldSection title={t4}>{t6}</FieldSection>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t(_temp2);
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t10;
  let t9;
  if ($[20] !== entity) {
    t9 = <Field di="investor_profile.occupation" entity={entity} />;
    t10 = <Field di="investor_profile.employer" entity={entity} />;
    $[20] = entity;
    $[21] = t10;
    $[22] = t9;
  } else {
    t10 = $[21];
    t9 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8 || $[25] !== t9) {
    t11 = <FieldSection title={t8}>{t9}{t10}</FieldSection>;
    $[23] = t10;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t) {
    t12 = t(_temp3);
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== isAutoDecrypting || $[30] !== t) {
    t13 = (value_0, isValueDecrypted_0) => isValueDecrypted_0 ? <FieldOrPlaceholder data={t($_3 => $_3.annualIncome.options[value_0])} /> : <FieldOrPlaceholder data={value_0} isLoading={isAutoDecrypting} />;
    $[29] = isAutoDecrypting;
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== entity || $[33] !== t13) {
    t14 = <Field di="investor_profile.annual_income" entity={entity} renderValue={t13} />;
    $[32] = entity;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t12 || $[36] !== t14) {
    t15 = <FieldSection title={t12}>{t14}</FieldSection>;
    $[35] = t12;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t) {
    t16 = t(_temp4);
    $[38] = t;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== isAutoDecrypting || $[41] !== t) {
    t17 = (value_1, isValueDecrypted_1) => isValueDecrypted_1 ? <FieldOrPlaceholder data={t($_5 => $_5.netWorth.options[value_1])} /> : <FieldOrPlaceholder data={value_1} isLoading={isAutoDecrypting} />;
    $[40] = isAutoDecrypting;
    $[41] = t;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== entity || $[44] !== t17) {
    t18 = <Field di="investor_profile.net_worth" entity={entity} renderValue={t17} />;
    $[43] = entity;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t16 || $[47] !== t18) {
    t19 = <FieldSection title={t16}>{t18}</FieldSection>;
    $[46] = t16;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t11 || $[50] !== t15 || $[51] !== t19 || $[52] !== t7) {
    t20 = <div className="flex flex-col gap-10 flex-1">{t7}{t11}{t15}{t19}</div>;
    $[49] = t11;
    $[50] = t15;
    $[51] = t19;
    $[52] = t7;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="hidden md:block w-px border-l border-solid border-tertiary mx-6" />;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== entity || $[56] !== isAutoDecrypting || $[57] !== t || $[58] !== vaultData) {
    t22 = isVaultDataEmpty(vaultData?.["investor_profile.funding_sources"]) ? null : <FieldSection title={t(_temp5)}><Field di="investor_profile.funding_sources" entity={entity} renderValue={value_2 => {
        if (Array.isArray(value_2)) {
          return <FieldOrPlaceholder data={createCapitalStringList(value_2.map(option => t($_7 => $_7.fundingSources.options[option])))} isLoading={isAutoDecrypting} />;
        }
        return <FieldOrPlaceholder data={value_2} isLoading={isAutoDecrypting} />;
      }} /></FieldSection>;
    $[55] = entity;
    $[56] = isAutoDecrypting;
    $[57] = t;
    $[58] = vaultData;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  let t23;
  if ($[60] !== t) {
    t23 = t(_temp6);
    $[60] = t;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== isAutoDecrypting || $[63] !== t) {
    t24 = value_3 => {
      if (Array.isArray(value_3)) {
        return <FieldOrPlaceholder data={createCapitalStringList(value_3.map(option_0 => t($_9 => $_9.investmentGoals.options[option_0 as InvestorProfileInvestmentGoal])))} isLoading={isAutoDecrypting} />;
      }
      return <FieldOrPlaceholder data={value_3} isLoading={isAutoDecrypting} />;
    };
    $[62] = isAutoDecrypting;
    $[63] = t;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  let t25;
  if ($[65] !== entity || $[66] !== t24) {
    t25 = <Field di="investor_profile.investment_goals" entity={entity} renderValue={t24} />;
    $[65] = entity;
    $[66] = t24;
    $[67] = t25;
  } else {
    t25 = $[67];
  }
  let t26;
  if ($[68] !== t23 || $[69] !== t25) {
    t26 = <FieldSection title={t23}>{t25}</FieldSection>;
    $[68] = t23;
    $[69] = t25;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  let t27;
  if ($[71] !== t) {
    t27 = t(_temp7);
    $[71] = t;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== isAutoDecrypting || $[74] !== t) {
    t28 = (value_4, isValueDecrypted_2) => isValueDecrypted_2 ? <FieldOrPlaceholder data={t($_11 => $_11.riskTolerance.options[value_4])} isLoading={isAutoDecrypting} /> : <FieldOrPlaceholder data={value_4} isLoading={isAutoDecrypting} />;
    $[73] = isAutoDecrypting;
    $[74] = t;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  let t29;
  if ($[76] !== entity || $[77] !== t28) {
    t29 = <Field di="investor_profile.risk_tolerance" entity={entity} renderValue={t28} />;
    $[76] = entity;
    $[77] = t28;
    $[78] = t29;
  } else {
    t29 = $[78];
  }
  let t30;
  if ($[79] !== t27 || $[80] !== t29) {
    t30 = <FieldSection title={t27}>{t29}</FieldSection>;
    $[79] = t27;
    $[80] = t29;
    $[81] = t30;
  } else {
    t30 = $[81];
  }
  let t31;
  if ($[82] !== t) {
    t31 = t(_temp8);
    $[82] = t;
    $[83] = t31;
  } else {
    t31 = $[83];
  }
  let t32;
  if ($[84] !== isAutoDecrypting || $[85] !== t) {
    t32 = value_5 => {
      if (Array.isArray(value_5)) {
        if (value_5.length === 0) {
          return <FieldOrPlaceholder data={t(_temp9)} isLoading={isAutoDecrypting} />;
        }
        return <FieldOrPlaceholder data={createCapitalStringList(value_5.map(option_1 => t($_14 => $_14.declarations.options[option_1 as InvestorProfileDeclaration])))} isLoading={isAutoDecrypting} />;
      }
      return <FieldOrPlaceholder data={value_5} isLoading={isAutoDecrypting} />;
    };
    $[84] = isAutoDecrypting;
    $[85] = t;
    $[86] = t32;
  } else {
    t32 = $[86];
  }
  let t33;
  if ($[87] !== entity || $[88] !== t32) {
    t33 = <Field di="investor_profile.declarations" entity={entity} renderValue={t32} />;
    $[87] = entity;
    $[88] = t32;
    $[89] = t33;
  } else {
    t33 = $[89];
  }
  let t34;
  if ($[90] !== entity || $[91] !== vaultData) {
    t34 = isVaultDataEmpty(vaultData?.["investor_profile.brokerage_firm_employer"]) ? null : <Field di="investor_profile.brokerage_firm_employer" entity={entity} />;
    $[90] = entity;
    $[91] = vaultData;
    $[92] = t34;
  } else {
    t34 = $[92];
  }
  let t35;
  if ($[93] !== entity || $[94] !== isAutoDecrypting || $[95] !== vaultData) {
    t35 = isVaultDataEmpty(vaultData?.["investor_profile.senior_executive_symbols"]) ? null : <Field di="investor_profile.senior_executive_symbols" entity={entity} renderValue={value_6 => {
      if (Array.isArray(value_6)) {
        return <FieldOrPlaceholder data={createStringList(value_6 as string[])} isLoading={isAutoDecrypting} />;
      }
      return <FieldOrPlaceholder data={value_6} isLoading={isAutoDecrypting} />;
    }} />;
    $[93] = entity;
    $[94] = isAutoDecrypting;
    $[95] = vaultData;
    $[96] = t35;
  } else {
    t35 = $[96];
  }
  let t36;
  if ($[97] !== entity || $[98] !== isAutoDecrypting || $[99] !== vaultData) {
    t36 = isVaultDataEmpty(vaultData?.["investor_profile.family_member_names"]) ? null : <Field di="investor_profile.family_member_names" entity={entity} renderValue={value_7 => {
      if (Array.isArray(value_7)) {
        return <FieldOrPlaceholder data={createStringList(value_7 as string[])} isLoading={isAutoDecrypting} />;
      }
      return <FieldOrPlaceholder data={value_7} isLoading={isAutoDecrypting} />;
    }} />;
    $[97] = entity;
    $[98] = isAutoDecrypting;
    $[99] = vaultData;
    $[100] = t36;
  } else {
    t36 = $[100];
  }
  let t37;
  if ($[101] !== entity || $[102] !== vaultData) {
    t37 = isVaultDataEmpty(vaultData?.["investor_profile.political_organization"]) ? null : <Field di="investor_profile.political_organization" entity={entity} />;
    $[101] = entity;
    $[102] = vaultData;
    $[103] = t37;
  } else {
    t37 = $[103];
  }
  let t38;
  if ($[104] !== entity || $[105] !== isAutoDecrypting || $[106] !== vaultData) {
    t38 = isVaultDataEmpty(vaultData?.["document.finra_compliance_letter"]) ? null : <Field di="document.finra_compliance_letter" entity={entity} renderValue={(value_8, isValueDecrypted_3) => isValueDecrypted_3 ? <FinraField base64Data={value_8 as string} /> : <FieldOrPlaceholder data={value_8} isLoading={isAutoDecrypting} />} />;
    $[104] = entity;
    $[105] = isAutoDecrypting;
    $[106] = vaultData;
    $[107] = t38;
  } else {
    t38 = $[107];
  }
  let t39;
  if ($[108] !== t31 || $[109] !== t33 || $[110] !== t34 || $[111] !== t35 || $[112] !== t36 || $[113] !== t37 || $[114] !== t38) {
    t39 = <FieldSection title={t31}>{t33}{t34}{t35}{t36}{t37}{t38}</FieldSection>;
    $[108] = t31;
    $[109] = t33;
    $[110] = t34;
    $[111] = t35;
    $[112] = t36;
    $[113] = t37;
    $[114] = t38;
    $[115] = t39;
  } else {
    t39 = $[115];
  }
  let t40;
  if ($[116] !== t22 || $[117] !== t26 || $[118] !== t30 || $[119] !== t39) {
    t40 = <div className="flex flex-col gap-10 flex-1">{t22}{t26}{t30}{t39}</div>;
    $[116] = t22;
    $[117] = t26;
    $[118] = t30;
    $[119] = t39;
    $[120] = t40;
  } else {
    t40 = $[120];
  }
  let t41;
  if ($[121] !== t20 || $[122] !== t40) {
    t41 = <div className="flex flex-col gap-6 md:flex-row md:gap-0">{t20}{t21}{t40}</div>;
    $[121] = t20;
    $[122] = t40;
    $[123] = t41;
  } else {
    t41 = $[123];
  }
  return t41;
};
export default InvestorProfileFields;
function _temp($) {
  return $.employmentStatus.title;
}
function _temp2($_1) {
  return $_1.occupation.title;
}
function _temp3($_2) {
  return $_2.annualIncome.title;
}
function _temp4($_4) {
  return $_4.netWorth.title;
}
function _temp5($_6) {
  return $_6.fundingSources.title;
}
function _temp6($_8) {
  return $_8.investmentGoals.title;
}
function _temp7($_10) {
  return $_10.riskTolerance.title;
}
function _temp8($_12) {
  return $_12.declarations.title;
}
function _temp9($_13) {
  return $_13.declarations.options.none;
}